// Generated from SVG to React Component
import React, { SVGProps } from "react";

export const PlusterSm = ({ color = "black", ...props }: SVGProps<SVGSVGElement>) => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <g clip-path="url(#clip0_12312_194)">
            <path d="M10.607 1.62195L1.62208 10.6069C1.23806 10.9909 1.23806 11.6136 1.62208 11.9976L4.00503 14.3805C4.38904 14.7645 5.01166 14.7645 5.39567 14.3805L14.3806 5.39555C14.7647 5.01153 14.7647 4.38892 14.3806 4.00491L11.9977 1.62196C11.6137 1.23794 10.9911 1.23794 10.607 1.62195Z" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
            <path d="M4.00503 1.61948L1.62208 4.00243C1.23806 4.38645 1.23806 5.00906 1.62208 5.39308L10.607 14.378C10.9911 14.7621 11.6137 14.7621 11.9977 14.378L14.3806 11.9951C14.7647 11.6111 14.7647 10.9885 14.3806 10.6045L5.39567 1.61948C5.01166 1.23547 4.38904 1.23547 4.00503 1.61948Z" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
            <path d="M9.66667 8L8 9.66667" stroke={color} strokeWidth="0.75" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M7.99967 6.33325L6.33301 7.99992" stroke={color} strokeWidth="0.75" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M158.666 -120H-74.667V113.333H158.666V-120Z" stroke={color} strokeWidth="0.666667" strokeLinecap="round" strokeLinejoin="round" />
        </g>
        <defs>
            <clipPath id="clip0_12312_194">
                <rect width="16" height="16" fill="white" />
            </clipPath>
        </defs>
    </svg>
);
